import { render, staticRenderFns } from "./influencer-allocation.vue?vue&type=template&id=56049ee4&scoped=true&"
import script from "./influencer-allocation.vue?vue&type=script&lang=js&"
export * from "./influencer-allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56049ee4",
  null
  
)

export default component.exports